import { render, staticRenderFns } from "./MediaPreferences.vue?vue&type=template&id=1194640d"
import script from "./MediaPreferences.vue?vue&type=script&lang=js"
export * from "./MediaPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports